<div class="header">
    <h1 mat-dialog-title>{{ data.title }}</h1>
</div>
<div mat-dialog-content>
    <p class="dialog-message">{{ data.message }}</p>
</div>
<div mat-dialog-actions style="justify-content: space-between;">
    <button class="sp-basic-button" mat-raised-button color="basic" (click)="cancel()">{{data.cancelText}}</button>
    <button class="sp-color-button" mat-raised-button color="accent" (click)="confirm()">{{data.confirmText}}</button>
</div>